import styled from "styled-components";
import { Colors, Fonts, Scale } from '../../themes';
import { deviceSize } from '../../constants/deviceSize'

export const Container = styled.div`
  ${props => props.containerStyle}
`

export const StyledButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  padding: 16px 0;
  background: ${props => props.bordered ? Colors.color3 : props.disabled ? Colors.color16 : props.backgroundColor};
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  ${props =>
    props.bordered &&
    `
      border: 1.5px solid ${props.borderColor};
      padding: 14.5px 0;
    `
  }
  :hover {
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  }
  
  .button-text {
    ${Fonts.FontRegular}
    ${Fonts.size.size16}
    color: ${props => props.disabled ? Colors.color7 : props.textColor};
    font-weight: 800;
    ${props => props.textStyle}
  }

  .icon-left {
    object-fit: contain;
    ${props=> props.iconLeftStyle}
  }

  .icon-right {
    object-fit: contain;
    ${props=> props.iconRightStyle}
  }

  ${props => props.buttonStyle}
`

export const StyledDropdown = styled.div`  
  ul {
    background-color: ${Colors.color3};
    width: ${props => props.dropdownWidth};
    z-index: 2;
    position: absolute;
    height: ${props => props.showDropdown ? 'auto' : '0px'};
    overflow: hidden;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    ${props => props.dropdowStyle}
  }

  ul li {
    ${Fonts.FontRegular}
    ${Fonts.size.size16}
    font-weight: 800;
    color: ${Colors.color2};
    padding: ${props => props.showDropdown ? '10px' : '0px'};
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }

  ul li:hover {
    cursor: pointer;
    ${props=> props.styleHoverDropdown}
  }
`